import { Controller } from "@hotwired/stimulus"

const formatUSD = (cents) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
    (cents || 0) / 100,
  )

// Drives the Unlimited signup tier picker:
//   - toggles the submit button's disabled state
//   - writes a live "Total today" breakdown (plan fee + credits − dev credit)
//   - updates the submit button label with the running total
//
// The radio inputs must expose the credit-package price via
// data-price-cents. The controller reads the monthly plan fee and any
// Developer upgrade credit off its own values.
export default class extends Controller {
  static targets = [
    "radio",
    "submit",
    "planFee",
    "credits",
    "developerCredit",
    "total",
  ]

  static values = {
    planFeeCents: { type: Number, default: 0 },
    developerCreditCents: { type: Number, default: 0 },
    submitBaseLabel: { type: String, default: "Start" },
  }

  connect() {
    this.update()
  }

  tierPicked() {
    this.update()
  }

  update() {
    const selected = this.radioTargets.find((r) => r.checked)
    const creditCents = selected
      ? parseInt(selected.dataset.priceCents || "0", 10)
      : 0
    const totalCents =
      this.planFeeCentsValue + creditCents - this.developerCreditCentsValue

    if (this.hasPlanFeeTarget) {
      this.planFeeTarget.textContent = formatUSD(this.planFeeCentsValue)
    }
    if (this.hasCreditsTarget) {
      this.creditsTarget.textContent = selected
        ? formatUSD(creditCents)
        : "Select a package"
      this.creditsTarget.classList.toggle("text-muted", !selected)
    }
    if (this.hasDeveloperCreditTarget) {
      this.developerCreditTarget.textContent =
        "−" + formatUSD(this.developerCreditCentsValue)
    }
    if (this.hasTotalTarget) {
      this.totalTarget.textContent = selected ? formatUSD(totalCents) : "—"
    }
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !selected
      this.submitTarget.value = selected
        ? `${this.submitBaseLabelValue} — ${formatUSD(totalCents)}`
        : this.submitBaseLabelValue
    }
  }
}
